import { useSidebarPinState } from '@backstage/core-components';
import { useBreakpoint } from '@backstage/ui';

/**
 * Whether the nav is the icon rail rather than the full column: unpinned by
 * the person (the button at its bottom, or Settings → Pin sidebar), or a
 * screen narrower than BUI's `sm` (768 px), where a full column would eat the
 * page.
 */
export function useNavCollapsed() {
  const { isPinned } = useSidebarPinState();
  const { up } = useBreakpoint();
  return !isPinned || !up('sm');
}
